module.exports = __webpack_public_path__ + "sn.svg?7439e079ceb7a54cac8536127c313aab";